let CancelToken;
let source;

const Config = require('~/config/default.env').default;

export default {
  namespaced: true,
  state: {
    product: [],
    loading: true,
  },
  mutations: {
    SET_PRODUCT(state, data) {
      state.product = data;
    },
    SET_LOAD_PRODUCT(state, data) {
      state.loading = data;
    },
  },
  actions: {
    getOurCuratedProducts({ commit, state, dispatch, rootState, rootGetters }) {
      // product list brand
      if (typeof source !== 'undefined') {
        source.cancel(false);
      }
      CancelToken = axios.CancelToken;
      source = CancelToken.source();
      const filter = {
        is_reviewed: true,
        is_use_filter: true,
      };

      const params = {
        filter,
        limit: rootState.$_Review.queryString.limit,
        skip: rootState.$_Review.queryString.skip,
      };

      if (rootState.$_Review.queryString.sort) {
        params.sort = rootState.$_Review.queryString.sort;
      }

      if (rootState.$_Review.queryString.brands) {
        params.filter['brand.id'] = {
          $in: rootState.$_Review.queryString.brands.split(','),
        };
      }

      if (rootState.$_Review.queryString.tags) {
        params.filter['tags.id'] = {
          $in: rootState.$_Review.queryString.tags.split(','),
        };
      }

      if (rootState.$_Review.queryString.origins) {
        params.filter['brand.country_tag_id'] = {
          $in: rootState.$_Review.queryString.origins.split(','),
        };
      }

      if (rootState.$_Review.queryString.category) {
        params.filter['categories.id'] = {
          $in: rootState.$_Review.queryString.category,
        };
      }

      if (rootState.$_Review.queryString.rating) {
        const filterQuery = rootState.$_Review.queryString.rating.split(',') || [];
        const rating = [];
        filterQuery.map((x) => {
          const intRating = Number(x);
          if (filterQuery.length > 1) {
            rating.push({
              'review_stats.average_rating': {
                $gte: intRating,
                $lte: intRating + 0.999,
              },
            });
          } else {
            rating.push({
              'review_stats.average_rating': { $gte: intRating },
            });
            rating.push({
              'review_stats.average_rating': { $lte: intRating + 0.999 },
            });
          }
        });
        if (filterQuery.length > 1) {
          params.filter['$and'] = [{ $or: rating }];
        } else {
          params.filter['$and'] = rating;
        }
      }

      if (rootState.$_Review.queryString.available_for) {
        if (
          rootState.$_Review.queryString.available_for.includes('sociolla') &&
          rootState.$_Review.queryString.available_for.includes('lulla')
        ) {
          params.filter['is_active_in_sociolla'] = true;
          params.filter['is_active_in_lulla'] = true;
        } else if (rootState.$_Review.queryString.available_for.includes('lulla')) {
          params.filter['is_active_in_lulla'] = true;
        } else {
          params.filter['is_active_in_sociolla'] = true;
        }
      }

      const paramSearch = { params: params, cancelToken: source.token };

      return axios
        .get(`${Config.MS_SOCO_PUBLIC_API_URL}/products/featured/trending`, paramSearch)
        .then((response) => {
          const datas = response.data.data;
          commit('SET_PRODUCT', datas);
          commit('SET_LOAD_PRODUCT', false);
        })
        .catch((err) => {
          commit('SET_PRODUCT', []);
          commit('SET_LOAD_PRODUCT', false);
        });
    },
  },
};
